import { View } from "binder"
import { CustomerAttributeViewModel } from "./customerAttribute-viewModel"

export class CustomerAttributeView extends View<CustomerAttributeViewModel>{
    GetViewUniqueId(): string {
        return "V-7F1C637E-3CDF-4CDE-AF74-5E7EA52246E4"
    }
    loadHtml(): string {
        let element = require('./customerAttribute.html').default;
        let style = require('./customerAttribute.less');
        return element;
    }
    constructor() {
       super();
    }
}
